<template>
  <es-drawer-bottom
    show="{{cxvipPopupShow}}"
    showDefaultNav
    navbarStyle="{{{background: 'transparent'}}}"
    customStyle="{{{height: '350px'}}}"
    bind:close="close"
  >
    <view class="container">
      <image class="vip-icon" src="{{vipicon}}"></image>
      <view class="title">开通12306畅行会员</view>
      <view class="sub-title">开通会员，享受<text class="highlight">双渠道抢票权益</text></view>
      <view bindtap="toOpenCxvip" class="open-btn">立即开通</view>
    </view>
  </es-drawer-bottom>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import { innerRouter, pagePath } from '@/common/jump'
  import store from '@/store'

  createComponent({
    props: {
      isCxvip: {
        type: Boolean,
      }
    },
    data() {
      return {
        vipicon: 'https://ut-static.udache.com/webx/sfc/7y81ZhEByDQkGAhhzl0fY_clipboard_image_1696929538559.png'
      }
    },
    computed: {
      ...store.mapState({
        cxvipPopupShow: 'login12306.cxvipPopupShow',
        cxvipPopupCloseCb: 'login12306.cxvipPopupCloseCb',
      }),
    },
    methods: {
      ...store.mapMutations({
        closeCxvipPopup: 'login12306.closeCxvipPopup',
        verifyCxvip: 'login12306.verifyCxvip',
        clearCxvipPopupCloseCb: 'login12306.clearCxvipPopupCloseCb',
      }),
      toOpenCxvip() {
        this.closeCxvipPopup()
        this.verifyCxvip(true)
      },
      close() {
        this.closeCxvipPopup()
        this.cxvipPopupCloseCb && this.cxvipPopupCloseCb()
        this.clearCxvipPopupCloseCb()
      }
    },
  })
</script>

<style lang='stylus' scoped>
  .container
    padding 0 20px
    box-sizing border-box
    display flex
    flex-direction column
    align-items center
    line-height 1
    .vip-icon
      margin -24px 0 17px
      width 110px
      height 110px
    .title
      font-family AlibabaPuHuiTi PingFangSC-Medium
      font-size 20px
      font-weight 500
      letter-spacing 0px
      color #000000
    .sub-title
      font-family PingFangSC-Regular
      font-size 14px
      font-weight normal
      letter-spacing 0px
      color #3D3D3D
      margin-top 12px
      .highlight
        color #FF6400
    .open-btn
      width 100%
      height 44px
      @extend .flex-center
      justify-content center
      border-radius 10px
      background-color #338FFF
      color #FFFFFF
      font-family PingFangSC-Medium
      font-size 15px
      font-weight normal
      letter-spacing 0px
      margin-top 57px
</style>

<script name='json'>
  module.exports = {
    component: true,
    usingComponents: {
      'es-drawer-bottom': '@didi/es-mpx-ui/lib/drawer-bottom'
    }
  }
</script>

